import { ExternalNumberDetail } from 'src/app/pages/extension-details/models/extension-detail-view.model';
import { ExtensionOption } from 'src/app/pages/extension-register/models/extension-option.interface';

export enum ChipInputType {
   PhoneNumber,
   Extension,
}
export interface ChipInputOption {
   id: number;
   type: ChipInputType;
   value: ExternalNumberDetail | ExtensionOption;
   extensionId: number | null;
   isDeleted: boolean;
}

export interface IncomingSuperviseeData {
   extensionSupervisees: Array<{
      extensionId: number;
      extensionSuperviseeId: number;
      name: string;
      number: number;
      superviseeExtensionId: number;
      supervisorExtensionId: number;
   }>;
   externalNumbers: Array<{
      accountId: number;
      externalNumber: number;
      externalNumberHistoryId: number;
   }>;
}
